export const spaceSearchQueryKeys = {
  all: ['spaceSearchQuery'] as const,
  queryKey: (query: string, spaceFilter: 'related' | 'visited') => [
    ...spaceSearchQueryKeys.all,
    query,
    spaceFilter,
  ],
};

/**
 * 방문한 모든 스페이스 목록 API query key
 */
export const visitedSpaceKeys = {
  all: ['visitedSpaces'] as const,
  lists: () => [...visitedSpaceKeys.all, 'list'] as const,
  list: (filters: string) =>
    [...visitedSpaceKeys.lists(), { filters }] as const,
  details: () => [...visitedSpaceKeys.all, 'detail'] as const,
  detail: (id: number) => [...visitedSpaceKeys.details(), id] as const,
};

/**
 * 내 역할이 부여된 스페이스 목록 API query key
 */
export const relatedMeSpaceKeys = {
  all: ['relatedMeSpaces'] as const,
  lists: () => [...relatedMeSpaceKeys.all, 'list'] as const,
  list: (filters: string) =>
    [...relatedMeSpaceKeys.lists(), { filters }] as const,
  details: () => [...relatedMeSpaceKeys.all, 'detail'] as const,
  detail: (id: number) => [...relatedMeSpaceKeys.details(), id] as const,
};
